import {Select, Text} from "@chakra-ui/react";
import React from "react";

export default function SelectComposto(props) {

    return (
        <>
            <Text w={'100%'} fontSize='lg' color={'black'}>
                <b>{props.ordem} - Escolha {props.tipo}</b>
            </Text>
            <Select id={'select01'} disabled={props.disable} color="blackAlpha.900" onChange={props.change}>
                <option value={'select'}>Selecione uma opção</option>
                {props.array.length !== 0 ? props.array.map((un) =>
                        <option key={un.id} value={un.id}>{un.nome}</option>
                ) : null}
            </Select>
        </>
    )
}